<template>
  <div class="background" :style="{display:display}">
    <div v-if="backLink && backLinkEnableForApp" @click="handleBackClick()" class="c-menu__link">
      <div class="bk-menu-icon"></div>
    </div>
    <!-- Hamburger menu -->
    <side-menu :backButtonOnLeft="backLink && backLinkEnableForApp" v-if="showMenu" ></side-menu>
    <!-- GE Logo -->
    <div class="ge-logo" v-show="showLogo"> </div>
  </div>
</template>

<script>
//  import Sidenpm Menu from './Side-Menu';
  import SideMenu from './TheSideMenu';
  import { EventBus } from '../assets/js/event-bus';

  export default {
    components: {
      SideMenu,
    },
    name: 'top-nav-section',
    /**
     * backlink - 'auto' app determine the backlink target
     *            ''  no backlink button
     *            '<routeName>' hardcode a route back link target
     */
    props: ['backLink', 'menus', 'display'],
    mounted() {
      EventBus.$on('back-clicked-event', this.handleBackClick);
      EventBus.$on('show-menu-event', this.handleShowMenu);
      EventBus.$on('show-logo-event', this.handleShowLogo);
    },
    data() {
      return {
        backLinkEnableForApp: true,  // Set false if back button is not required.
        currentClickTime: Date.now(),
        lastClickTime: Date.now(),
        showMenu: false,
        showLogo: true,
      };
    },
    methods: {
      handleShowMenu(isMenuShow) {
        this.showMenu = isMenuShow;
      },
      handleShowLogo(isLogoShow) {
        this.showLogo = isLogoShow;
      },
      handleBackClick() {
        // console.log('****************** Back Button is clicked**********************');
        // debugger;
        // backLink is defined
        this.currentClickTime = Date.now();
        if ((this.currentClickTime - this.lastClickTime) < 500) return;

        // console.log('****************** Back Button is OK **********************');
        this.lastClickTime = this.currentClickTime;

        if (typeof this.backLink !== 'boolean' && this.backLink !== 'auto') {
          // console.log('backlink is defined:' + this.backLink);
          if (typeof this.backLink === 'string') {
            this.$router.push({ name: this.backLink });
          } else {
            // debugger;
            this.$router.push(this.backLink);
          }
        } else if (window.routeHistory.length > 0) {
          // debugger;
          this.$router.go(-1);
        } else {
          // this is where the back button is enabled without previous history
          // i.e user directly access a deep linked page with back button triggered.
          // this is where we go up one level to its parent otherwise, home.
          const fullPath = window.app.$router.history.current.fullPath;
          const parentPath = fullPath.substr(0, fullPath.lastIndexOf('/'));
          if (parentPath) {
            this.$router.push({ path: parentPath });
          } else {
            this.$router.push({ name: 'Home' });
          }
        }
      },
    },
    watch: {
//      backLink: function (value) {
//         console.log ('Watch: TopNavSec backlink updated:' + value);
//      },
    },
    computed: {
    },
  };
</script>

<style lang="css" rel="stylesheet/css">
  .bk-menu-icon {
    background: url(~assets/images/back_button.png) no-repeat;
    /*margin: 15px 0 0 20px;*/
    /*margin: 33px 0 0 1.04167%;*/
    /*margin: 33px 0 0 20px !important;*/
    position: absolute;
    top: 33px;
    left: 20px;
    width: 18px !important;
    height: 33px !important;
    /*width: 1.9%;*/
    z-index: 10;
    cursor: pointer;
    padding: 20px;
  }

  .ge-logo {
    background: url(~assets/images/ge_logo.png) no-repeat;
    background-size: cover;
    position: absolute;
    width: 94px;
    height: 94px;
    left: 68px;
    top: 61px;
    z-index: 10;
  }

</style>



// WEBPACK FOOTER //
// TheTopNavSection.vue?66456e6d